import { Option } from '@akin-home/amplify';
import { toSnakeCase } from '@akin-home/utils/strings';
import { OptionModel, Options, OptionType } from './types';

export const createOptionModel = (
  defaults?: Partial<OptionModel>
): OptionModel => {
  const type = defaults?.type || OptionType.BUDGET;

  return {
    id: '',
    label: '',
    type,
    code: type,
    ...defaults,
  };
};

export const setOptionType = (
  option: OptionModel,
  type: OptionType
): OptionModel => {
  return {
    ...option,
    type,
    code: type + '_' + toSnakeCase(option.label),
  };
};

/**
 * Gets the options for a given type
 */
export const getOptionsForType = (
  options: Options,
  type: string
): OptionModel[] => options[type] || [];

export const filterOptionsByType =
  (type: OptionType) =>
  (options?: OptionModel[]): OptionModel[] =>
    options?.filter((opt) => opt.type === type) || [];

export const getOptionIDorNull = (opt?: OptionModel) => (opt ? opt.id : null);

export const optionGraphqlToModel = (option: Option): OptionModel =>
  ({ ...option } as OptionModel);

export const optionGraphqlToModelOrUndefined = (opt?: Option | null) =>
  opt ? optionGraphqlToModel(opt) : undefined;
